// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employee-earnings",
  Create: "/pyr/employee-earnings",
  Update: "/pyr/employee-earnings",
  Import: "/pyr/employee-earnings/import",
};
